module.exports = __webpack_public_path__ + "static/MIMA-Logo -f4ea3e8b21406a1eb4959272f0e13744.jpg";